<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaConvenios"
        title-table="Convênio"
        module="convenioSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_CONVENIO_INSERIR"
        view-permission="ROLE_CONVENIO_CONSULTAR"
        edit-permission="ROLE_CONVENIO_ATUALIZAR"
        delete-permission="ROLE_CONVENIO_DELETAR"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormConvenio
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormConvenio from './forms/FormConvenio.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormConvenio,
  },
  computed: {
    ...mapState('convenioSettingsModule', {
      listaConvenios: state => state.listaConvenios,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Data Início',
          field: 'dataInicio',
          type: 'date',
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss'Z'",
          dateOutputFormat: 'dd/MM/yyyy',
        },
        {
          label: 'Data Fim',
          field: 'dataTermino',
          type: 'date',
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss'Z'",
          dateOutputFormat: 'dd/MM/yyyy',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('convenioSettingsModule/resetConvenio')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('convenioSettingsModule/prepareToEditConvenio', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
